import CompanyInfoImg from "./../assets/CompanyInfo/campanyinfo.png";
function CompanyInfo() {
  return (
    <div className="w-full flex justify-center items-center ">
      <div className="md:w-1/2">
        <img
          src={CompanyInfoImg}
          alt="company info"
          className="w-full h-full"
        />
      </div>
    </div>
  );
}

export default CompanyInfo;
